import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

import arrowIcon from "../img/arrow.png";
import plusIcon from "../img/plus.png";
import gearIcon from "../img/gear.png";
import trashIcon from "../img/trash.webp";
import { Alert, Button, ButtonGroup, Col, Form, Modal, Row } from "react-bootstrap";
import { fieldTypes } from "../globalVariables";
import { useConfig } from "../ConfigContext";
import { FilterGenerator } from "./FilterGenerator";
import { isJSON } from "../pureFunctions";

const initField = {
   heading: { column: "heading", type: "TEXT" },
   kachelId: { column: "kachel_id", type: "TEXT" },
   type: { column: "type", type: "TEXT" },
   name: { column: "name", type: "TEXT" },
   tenant: { column: "tenant", type: "TEXT" },
   x: { column: "x", type: "INTEGER" },
   y: { column: "y", type: "INTEGER" },
   filter: { column: "filter", type: "JSONB" },
   options: { column: "options", type: "JSONB" },
   optionNames: { column: "option_names", type: "JSONB" },
   onOffice: { column: "on_office", type: "TEXT" },
   module: { column: "module", type: "TEXT" },
   title: { column: "title", type: "TEXT" },
   ai: { column: "ai", type: "INTEGER" },
   multi: { column: "multi", type: "BOOL" },
   maxLength: { column: "max_length", type: "INTEGER" },
   step: { column: "step", type: "INTEGER" },
   richText: { column: "rich_text", type: "BOOL" },
   readOnly: { column: "read_only", type: "BOOL" },
   optional: { column: "optional", type: "BOOL" },
   minDate: { column: "min_date", type: "TEXT" },
   autoComplete: { column: "auto_complete", type: "BOOL" },
   deprecated: { column: "deprecated", type: "BOOL" },
   buttonName: { column: "button_name", type: "TEXT" },
   style: { column: "style", type: "JSONB" },
   respField: { column: "resp_field", type: "TEXT" },
   channelId: { column: "channel_id", type: "TEXT" },
   content: { column: "content", type: "TEXT" },
   contentData: { column: "content_data", type: "JSONB" },
};

export default function EditField({ rowIndex, colIndex, data, allKacheln, setAllKacheln, fieldconfiguration }) {
   const [showEdit, setShowEdit] = useState(false);

   /*  const [felder, setFelder] = useState(
      allKacheln[data.stufenId].kachel.filter((item) => item.kachelId === data.kachelId)[0].fields,
   ); */

   function addFeld(x, y) {
      // setShow(true);
      console.log(data);
      const currentKachel = structuredClone(
         allKacheln[data.stufenId].kachel.find((item) => item.kachelId === data.kachelId),
      );

      let newFelder = structuredClone(currentKachel.fields);
      let element = {
         type: "text",
         heading: "",
         name: allKacheln[data.stufenId].kuerzel + "" + currentKachel.kuerzel + "_",
      };
      if (y !== 0) {
         newFelder.splice(rowIndex + (y > 0 ? 1 : 0), 0, []);
      } else {
         insertFeld(x, y, element, newFelder);
      }
      let kachelIndex = allKacheln[data.stufenId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.stufenId].kachel[kachelIndex].fields = newFelder;
      setAllKacheln(newKacheln);
   }

   function editFeld() {
      setShowEdit(true);
      // setFeldData(data);
   }

   function saveFeld(newData) {
      let kachelIndex = allKacheln[data.stufenId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.stufenId].kachel[kachelIndex].fields[rowIndex][colIndex] = newData;
      setAllKacheln(newKacheln);
   }

   function shiftFeld(x, y) {
      let newFelder = structuredClone(
         allKacheln[data.stufenId].kachel.filter((item) => item.kachelId === data.kachelId)[0].fields,
      );

      const element = newFelder[rowIndex].splice(colIndex, 1)[0];
      insertFeld(x, y, element, newFelder);
      let kachelIndex = allKacheln[data.stufenId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.stufenId].kachel[kachelIndex].fields = newFelder;
      setAllKacheln(newKacheln);
   }

   function removeFeld() {
      let newFelder = structuredClone(
         allKacheln[data.stufenId].kachel.filter((item) => item.kachelId === data.kachelId)[0].fields,
      );

      const element = newFelder[rowIndex].splice(colIndex, 1)[0];
      let kachelIndex = allKacheln[data.stufenId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.stufenId].kachel[kachelIndex].fields = newFelder;
      setAllKacheln(newKacheln);
   }

   function removeRow() {
      let newFelder = structuredClone(
         allKacheln[data.stufenId].kachel.find((item) => item.kachelId === data.kachelId).fields,
      );

      const element = newFelder.splice(rowIndex, 1);
      let kachelIndex = allKacheln[data.stufenId].kachel.findIndex((item) => item.kachelId === data.kachelId);
      console.log(kachelIndex);
      let newKacheln = structuredClone(allKacheln);
      newKacheln[data.stufenId].kachel[kachelIndex].fields = newFelder;
      setAllKacheln(newKacheln);
   }

   function insertFeld(x, y, element, newFelder) {
      console.log("Insert Feld");

      if (x > 0) {
         newFelder[rowIndex].splice(colIndex + 1, 0, element)[0];
      } else if (x < 0) {
         newFelder[rowIndex].splice(colIndex - 1, 0, element)[0];
      } else if (y < 0) {
         if (newFelder[rowIndex - 1]) {
            newFelder[rowIndex - 1].splice(
               newFelder[rowIndex - 1].length > colIndex ? colIndex : newFelder[rowIndex - 1].length,
               0,
               element,
            )[0];
         } else {
            newFelder.unshift([element]);
         }
      } else if (y > 0) {
         if (newFelder[rowIndex + 1]) {
            newFelder[rowIndex + 1].splice(
               newFelder[rowIndex + 1].length > colIndex ? colIndex : newFelder[rowIndex + 1].length,
               0,
               element,
            )[0];
         } else {
            console.log(newFelder);
            console.log(rowIndex);

            newFelder.push([element]);
         }
      } else {
         console.log("Add to empty Row");

         newFelder[rowIndex].push(element);
      }
   }

   return (
      <>
         {colIndex === "empty" ? (
            <Col>
               <ButtonGroup className="w-100 m-0 p-0">
                  <Button
                     variant="outline-dark"
                     onClick={() => {
                        removeRow();
                     }}
                  >
                     Reihe entfernen
                  </Button>
                  <Button
                     variant="outline-dark"
                     onClick={(e) => {
                        e.preventDefault();
                        addFeld(0, 0);
                     }}
                  >
                     Feld hinzufügen
                  </Button>
               </ButtonGroup>
            </Col>
         ) : (
            <div className="kachel-edit">
               {showEdit && (
                  <EditModal
                     show={showEdit}
                     setShow={setShowEdit}
                     data={allKacheln[data.stufenId].kachel.filter((item) => item.kachelId === data.kachelId)[0].fields}
                     rowIndex={rowIndex}
                     colIndex={colIndex}
                     saveFeld={saveFeld}
                     fieldconfiguration={fieldconfiguration}
                     allKacheln={allKacheln}
                  />
               )}

               <div>
                  <button
                     className="kachel-edit-btn"
                     title="Feld bearbeiten"
                     style={{ position: "absolute", top: 28, right: 90, height: 40, boxShadow: "0 0 10px #0006" }}
                     onClick={(e) => {
                        e.preventDefault();
                        editFeld();
                     }}
                  >
                     <img src={gearIcon} alt="Feld bearbeiten" height={24} />
                  </button>
                  <button
                     className="kachel-edit-btn"
                     title="Feld entfernen"
                     style={{ position: "absolute", top: 28, right: 40, height: 40, boxShadow: "0 0 10px #0006" }}
                     onClick={(e) => {
                        e.preventDefault();
                        removeFeld();
                     }}
                  >
                     <img src={trashIcon} alt="Feld entfernen" height={24} />
                  </button>
                  <div style={{ top: -24, transform: "rotate(270deg)" }} className="kachel-edit-btn-group">
                     <button
                        className="kachel-edit-btn"
                        onClick={(e) => {
                           e.preventDefault();
                           addFeld(0, -1);
                        }}
                     >
                        <img src={plusIcon} height={14} />
                     </button>
                     <button
                        className="kachel-edit-btn"
                        title="Nach oben verschieben"
                        disabled={rowIndex === 0}
                        onClick={(e) => {
                           e.preventDefault();
                           shiftFeld(0, -1);
                        }}
                     >
                        <img src={arrowIcon} height={16} />
                     </button>
                  </div>
                  <div style={{ right: -8, transform: "rotate(0deg)" }} className="kachel-edit-btn-group">
                     <button
                        className="kachel-edit-btn"
                        onClick={(e) => {
                           e.preventDefault();
                           addFeld(1, 0);
                        }}
                     >
                        <img src={plusIcon} height={14} />
                     </button>
                     <button
                        className="kachel-edit-btn"
                        title="Nach rechts verschieben"
                        onClick={(e) => {
                           e.preventDefault();
                           shiftFeld(1, 0);
                        }}
                     >
                        <img src={arrowIcon} height={16} />
                     </button>
                  </div>

                  <div style={{ bottom: -24, transform: "rotate(90deg)" }} className="kachel-edit-btn-group">
                     <button
                        className="kachel-edit-btn"
                        onClick={(e) => {
                           e.preventDefault();
                           addFeld(0, 1);
                        }}
                     >
                        <img src={plusIcon} height={14} />
                     </button>
                     <button
                        className="kachel-edit-btn"
                        title="Nach unten verschieben"
                        onClick={(e) => {
                           e.preventDefault();
                           shiftFeld(0, 1);
                        }}
                     >
                        <img src={arrowIcon} height={16} />
                     </button>
                  </div>
                  <div style={{ left: -8, transform: "rotate(180deg)" }} className="kachel-edit-btn-group">
                     <button
                        className="kachel-edit-btn"
                        onClick={(e) => {
                           e.preventDefault();
                           addFeld(-1, 0);
                        }}
                     >
                        <img src={plusIcon} height={14} />
                     </button>
                     <button
                        className="kachel-edit-btn"
                        title="Nach links verschieben"
                        disabled={colIndex === 0}
                        onClick={(e) => {
                           e.preventDefault();
                           shiftFeld(-1, 0);
                        }}
                     >
                        <img src={arrowIcon} height={16} />
                     </button>
                  </div>
               </div>
            </div>
         )}
      </>
   );
}

function EditModal({ setShow, show, data, rowIndex, colIndex, saveFeld, fieldconfiguration, allKacheln }) {
   const [feldKurzel, setFeldKurzel] = useState("");
   const [feldData, setFeldData] = useState(() => {
      const fData = data[rowIndex][colIndex];
      console.log(fData);

      return {
         ...fData,
         ...(fData.filter ? { filter: JSON.stringify(fData.filter, null, 2) } : {}),
         ...(fData.contentData ? { contentData: JSON.stringify(fData.contentData) } : {}),
         ...(fData.options ? { options: JSON.stringify(fData.options) } : {}),
         ...(fData.optionNames ? { options: JSON.stringify(fData.optionNames) } : {}),

         isOnOffice: !!fData?.onOffice,
      };
   });
   const config = useConfig();

   function editFeld(name, value, oOFieldData, module) {
      console.log(value);
      if (name === "onOffice") {
         setFeldData((prev) => ({
            ...prev,
            onOffice: value,
            module: module,
            name: value,
            type: oOFieldData.type,
            heading: oOFieldData.label,
            ...(oOFieldData.length ? { maxLength: oOFieldData.length } : {}),
            // ...(prev.filter ? { filter: JSON.stringify(prev.filter) } : {}),
         }));
      } else if (name === "type" && value === "teamsbutton") {
         setFeldData((prev) => ({ ...prev, type: value, optional: true }));
      } else {
         setFeldData((prev) => ({ ...prev, [name]: value }));
      }
   }

   return (
      <Modal show={show} className="" size="xl" onHide={() => setShow(false)}>
         <Modal.Header closeButton>
            <Modal.Title>Feld bearbeiten</Modal.Title>
         </Modal.Header>
         <Modal.Body>
            <Form>
               <Row>
                  <Col>
                     <Form.Group className="mb-3 ">
                        <Form.Label>Ist ein onOffice-Feld?{feldData.isOnOffice} </Form.Label>

                        <Form.Select
                           className={""}
                           name={"isOnOffice"}
                           onChange={(e) => {
                              editFeld(e.target.name, e.target.value);
                           }}
                           value={feldData.isOnOffice}
                        >
                           <option value={false}>Nein</option>
                           <option value={true}>Ja</option>
                        </Form.Select>
                     </Form.Group>
                  </Col>
               </Row>
               {feldData.isOnOffice && (
                  <Row>
                     <Col>
                        <Form.Group className="mb-3 ">
                           <Form.Label>Module</Form.Label>

                           <Form.Select
                              className={""}
                              name={"module"}
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.value);
                              }}
                              value={feldData.module}
                           >
                              <option value=""></option>
                              <option value="estate">Immobilienfeld</option>
                              <option value="address">Adressenfeld</option>
                           </Form.Select>
                        </Form.Group>
                     </Col>
                     {feldData.module && (
                        <Col>
                           <Form.Group className="mb-3 ">
                              <Form.Label>onOffice-Feldname</Form.Label>

                              <Select
                                 name={"onOffice"}
                                 // className="form-control"
                                 // classNamePrefix="react-select"
                                 styles={{
                                    control: (baseStyles, state) => ({
                                       ...baseStyles,
                                       borderRadius: "10px",
                                       border: "solid 2px #eee",
                                    }),
                                 }}
                                 placeholder="..."
                                 options={
                                    fieldconfiguration &&
                                    fieldconfiguration[feldData.module] &&
                                    Object.keys(fieldconfiguration[feldData.module])
                                       .filter((configKey) => {
                                          let filterResult = true;
                                          const fieldObj = fieldconfiguration[feldData.module]?.[configKey];
                                          if (
                                             // Object.values(config[feldData.module]).includes(configKey) ||
                                             fieldObj.type === "dividingline" ||
                                             fieldObj.type === "redhint" ||
                                             fieldObj.type === "blackhint" ||
                                             fieldObj.type === "datei" ||
                                             configKey === "label"
                                          ) {
                                             filterResult = false;
                                          }

                                          return filterResult;
                                       })
                                       .map((fieldKey, index) => {
                                          return {
                                             value: fieldKey,
                                             label: `${fieldconfiguration[feldData.module]?.[fieldKey]?.label} (${fieldconfiguration[feldData.module]?.[fieldKey]?.type})`,
                                          };
                                       })
                                       .sort((a, b) => {
                                          if (a.label > b.label) return 1;
                                          else return -1;
                                       })
                                 }
                                 onChange={(e) => {
                                    console.log(e);

                                    editFeld(
                                       "onOffice",
                                       e.value,
                                       fieldconfiguration[feldData.module]?.[e.value],
                                       feldData.module,
                                    );
                                 }}
                                 value={
                                    fieldconfiguration[feldData.module]?.[feldData.onOffice]
                                       ? {
                                            value: feldData.onOffice,
                                            label: fieldconfiguration[feldData.module]?.[feldData.onOffice]?.label,
                                         }
                                       : null
                                 }
                              />
                           </Form.Group>
                        </Col>
                     )}
                  </Row>
               )}
               {feldData.onOffice && feldData.module && (
                  <Row>
                     <Alert>
                        <h5 className="mb-3">
                           {fieldconfiguration[feldData?.module]?.[feldData.onOffice]?.label}{" "}
                           <small>({feldData?.heading})</small>
                        </h5>

                        <strong>Feldname: </strong>
                        <p
                           style={{
                              whiteSpace: "pre-wrap",
                              fontFamily: "monospace",
                              border: "solid 1px #0005",
                              padding: "5px",
                           }}
                        >
                           {feldData.onOffice}
                        </p>
                        <strong>Typ: </strong>
                        <p
                           style={{
                              whiteSpace: "pre-wrap",
                              fontFamily: "monospace",
                              border: "solid 1px #0005",
                              padding: "5px",
                           }}
                        >
                           {fieldconfiguration[feldData.module]?.[feldData.onOffice]?.type}
                        </p>
                        <strong>oO-Feldfilter: </strong>
                        <p
                           style={{
                              whiteSpace: "pre-wrap",
                              fontFamily: "monospace",
                              border: "solid 1px #0005",
                              padding: "5px",
                           }}
                        >
                           {JSON.stringify(
                              fieldconfiguration[feldData.module]?.[feldData.onOffice].filters ?? "",
                              null,
                              2,
                           )}
                        </p>

                        <strong>oO-Select-Werte: </strong>
                        <p
                           style={{
                              whiteSpace: "pre-wrap",
                              fontFamily: "monospace",
                              border: "solid 1px #0005",
                              padding: "5px",
                           }}
                        >
                           {JSON.stringify(
                              fieldconfiguration[feldData.module]?.[feldData.onOffice].permittedvalues ?? "",
                              null,
                              2,
                           )}
                        </p>
                     </Alert>
                  </Row>
               )}
               <Row>
                  <Col>
                  {feldData.isOnOffice&&<div className="my-1 p-1" style={{ background: "#d00", color: "#fff" }}>
                                 Vorsicht experimentell! Bei onOffice-Feldern kann es zu Fehler kommen, wenn dieses Feld manuell geändert wird, weil die Feldarten möglicherweise nicht kompatibel sind. 
                              </div>}
                           <Form.Group className="mb-3 ">
                              <Form.Label>Typ</Form.Label>

                              <Form.Select
                                 className={""}
                                 name={"type"}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                 }}
                                 value={feldData.type}
                              >
                                 <option value=""></option>
                                 {Object.keys(fieldTypes).map((fieldType, index) => {
                                    return (
                                       <option value={fieldType} key={fieldType}>
                                          {fieldTypes[fieldType]}
                                       </option>
                                    );
                                 })}
                              </Form.Select>
                           </Form.Group>
                        </Col>
               </Row>
               {!feldData.isOnOffice && (
                  <>
                     <Row>
                        
                        <Col>
                           {feldData.type === "teamsbutton" ? (
                              <Form.Group className="mb-3">
                                 <Form.Label>buttonName</Form.Label>
                                 <Form.Control
                                    autoComplete="off"
                                    placeholder="Nachricht in Kanal XYZ"
                                    className={""}
                                    onChange={(e) => {
                                       editFeld(e.target.name, e.target.value);
                                    }}
                                    name={"buttonName"}
                                    value={feldData.buttonName}
                                 />
                              </Form.Group>
                           ) : (
                              <Form.Group className="mb-3">
                                 <Form.Label>Überschrift</Form.Label>
                                 <Form.Control
                                    autoComplete="off"
                                    placeholder="z.B. angefordert bei"
                                    className={""}
                                    onChange={(e) => {
                                       editFeld(e.target.name, e.target.value);
                                    }}
                                    name={"heading"}
                                    value={feldData.heading}
                                 />
                              </Form.Group>
                           )}
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label>
                                 interne Feldbezeichnung (zusammenhängend ohne Sonderzeichen und Umlaute)
                              </Form.Label>
                              <Form.Control
                                 autoComplete="off"
                                 placeholder="z.B. DBAW_angefDat"
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                 }}
                                 name={"name"}
                                 value={feldData.name}
                              />
                           </Form.Group>
                        </Col>
                     </Row>
                  </>
               )}

               {feldData.type === "select" && (
                  <>
                     <Row>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label>
                                 Auswahloptionen{" "}
                                 <small>
                                    (JSON-Array) Zusätzlich "Sonstiges" anfügen, falls optionales Textfeld erwünscht.
                                 </small>
                              </Form.Label>
                              <Form.Control
                                 placeholder='z.B. ["Notariat", "Bauamt", "Rathaus", "Sonstiges"]'
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                    // editFeld(e.target.name, e.target.value.split(","));
                                    // editFeld(e.target.name, e.target.value.replace(/\s/g, "").split(","));
                                 }}
                                 name={"options"}
                                 value={feldData.options}
                                 // value={feldData.options ? feldData.options.join(",") : ""}
                              />
                           </Form.Group>
                           {!isJSON(feldData.options) && (
                              <div className="mt-1 p-1" style={{ background: "#d00", color: "#fff" }}>
                                 invalide Syntax
                              </div>
                           )}
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label>
                                 Bezeichnung der Auswahloptionen (optional)
                                 <small>(JSON-Array)</small>
                              </Form.Label>
                              <Form.Control
                                 placeholder='z.B. ["Notariat", "Bauamt", "Rathaus", "Sonstiges"]'
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                    // editFeld(e.target.name, e.target.value.split(","));
                                    // editFeld(e.target.name, e.target.value.replace(/\s/g, "").split(","));
                                 }}
                                 name={"optionNames"}
                                 value={feldData.optionNames}
                                 // value={feldData.options ? feldData.options.join(",") : ""}
                              />
                           </Form.Group>
                           {!isJSON(feldData.options) && (
                              <div className="mt-1 p-1" style={{ background: "#d00", color: "#fff" }}>
                                 invalide Syntax
                              </div>
                           )}
                        </Col>
                     </Row>
                  </>
               )}

               {feldData.type === "teamsbutton" && (
                  <>
                     <Row>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label>style (JSON)</Form.Label>
                              <Form.Control
                                 placeholder=""
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                 }}
                                 name={"style"}
                                 value={feldData.style}
                              />
                           </Form.Group>
                           {!isJSON(feldData.style) && (
                              <div className="mt-1 p-1" style={{ background: "#d00", color: "#fff" }}>
                                 invalide Syntax
                              </div>
                           )}
                        </Col>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label title="(interne Feldbezeichnung) Feld wird nach dem Senden der Teamsnachricht mit Zeitpunkt und Name des Senders beschrieben">
                                 respField*
                              </Form.Label>
                              <Form.Control
                                 placeholder=""
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                 }}
                                 name={"respField"}
                                 value={feldData.respField}
                              />
                           </Form.Group>
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label title="im Kanal auf '...', dann Link teilen und hier einfügen (Feld dient nur zum Ermitteln von channelId und teamId und bleibt leer)">
                                 Weblink vom Teams-Kanal hier einfügen*
                              </Form.Label>
                              <Form.Control
                                 placeholder=""
                                 className={""}
                                 onChange={(e) => {
                                    if (e.target.value) {
                                       try {
                                          const url = new URL(e.target.value);
                                          const match = url.pathname.match(/\/l\/channel\/([^/]+)/);
                                          const parsedLink = {
                                             channelId: match ? match[1] : null,
                                             // channelId: match ? decodeURIComponent(match[1]) : null,
                                             groupId: url.searchParams.get("groupId"),
                                             tenantId: url.searchParams.get("tenantId"),
                                          };
                                          console.log(parsedLink);
                                          if (parsedLink.channelId && parsedLink.groupId) {
                                             editFeld("channelId", parsedLink.channelId);
                                             editFeld("teamId", parsedLink.groupId);
                                             e.target.value = "";
                                          } else {
                                             throw Error;
                                             /* https://teams.microsoft.com/l/Home?groupId=5f9e0c1e-8a8f87&tenantId=f6e03a */
                                          }
                                       } catch (error) {
                                          window.alert(
                                             `Link konnte nicht erkannt werden!\n
Der Link sollte folgendes Format haben:
https://teams.microsoft.com/l/channel/19%3AYNw...%40thread.tacv2/Home?groupId=5f9e0c1e-8a8...f87&tenantId=f6e03a...`,
                                          );
                                       }
                                    }
                                 }}
                              />
                           </Form.Group>
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label>channelId</Form.Label>
                              <Form.Control
                                 placeholder="Z.B. 19%3A9..."
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                 }}
                                 name={"channelId"}
                                 value={feldData.channelId}
                              />
                           </Form.Group>
                        </Col>

                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label>GroupId (teamId)</Form.Label>
                              <Form.Control
                                 placeholder="Z.B. 3645b...."
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                 }}
                                 name={"teamId"}
                                 value={feldData.teamId}
                              />
                           </Form.Group>
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label>content</Form.Label>
                              <Form.Control
                                 placeholder="Z.B. Bei Objekt $objektnr_extern& von $benutzer$ sollen die Bilder bearbeitet werden."
                                 style={{ minHeight: "100px", fieldSizing: "content" }}
                                 as="textarea"
                                 autoComplete="off"
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                 }}
                                 name={"content"}
                                 value={feldData.content}
                              />
                           </Form.Group>
                        </Col>
                     </Row>
                     <Row>
                        <Col>
                           <Form.Group className="mb-3">
                              <Form.Label>contentData (string-Array)</Form.Label>
                              <Form.Control
                                 placeholder='zB. ["objektnr_extern","benutzer"]'
                                 className={""}
                                 onChange={(e) => {
                                    editFeld(e.target.name, e.target.value);
                                 }}
                                 name={"contentData"}
                                 value={feldData.contentData}
                              />
                              {!isJSON(feldData.contentData) && (
                                 <div className="mt-1 p-1" style={{ background: "#d00", color: "#fff" }}>
                                    invalide Syntax
                                 </div>
                              )}
                           </Form.Group>
                        </Col>
                     </Row>
                  </>
               )}

               <Row>
                  <Col>
                     <Form.Group className="mb-3">
                        <Form.Label>Wichtigkeit für KI (0-10)</Form.Label>
                        <Form.Control
                           value={feldData.ai}
                           type="number"
                           onChange={(e) => {
                              if (e.target.value >= 0 && e.target.value <= 10) editFeld(e.target.name, e.target.value);
                           }}
                           name={"ai"}
                        />
                     </Form.Group>
                  </Col>
                  {feldData.type === "number" && (
                     <Col>
                        <Form.Group className="mb-3">
                           <Form.Label>Schrittweite (Nummern)</Form.Label>
                           <Form.Control
                              value={feldData.step}
                              type="number"
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.value);
                              }}
                              name={"step"}
                           />
                        </Form.Group>
                     </Col>
                  )}
                  {["text", "textarea"].includes(feldData.type) && (
                     <Col>
                        <Form.Group className="mb-3">
                           <Form.Label>Maximale Text-Länge</Form.Label>
                           <Form.Control
                              value={feldData.maxLength}
                              type="number"
                              step={1}
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.value);
                              }}
                              name={"maxLength"}
                           />
                        </Form.Group>
                     </Col>
                  )}
               </Row>
               <Row>
                  {!["teamsbutton"].includes(feldData.type) && (
                     <Col>
                        <Form.Group className="mb-3" controlId="optional">
                           <Form.Check
                              inline
                              className="checkbox-container"
                              label="optional"
                              name="optional"
                              checked={feldData.optional}
                              type="checkbox"
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.checked);
                              }}
                              id={"optional"}
                           />
                        </Form.Group>
                     </Col>
                  )}
                  {!["teamsbutton"].includes(feldData.type) && (
                     <Col>
                        <Form.Group className="mb-3" controlId="readOnly">
                           <Form.Check
                              inline
                              className="checkbox-container"
                              label="schreibgeschützt"
                              name="readOnly"
                              checked={feldData.readOnly}
                              type="checkbox"
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.checked);
                              }}
                              id={"readOnly"}
                           />
                        </Form.Group>
                     </Col>
                  )}
               </Row>
               <Row>
                  {["text", "textarea"].includes(feldData.type) && (
                     <Col>
                        <Form.Group className="mb-3" controlId="richText">
                           <Form.Check
                              inline
                              className="checkbox-container"
                              label="Textformatierung aktiv"
                              name="richText"
                              checked={feldData.richText}
                              type="checkbox"
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.checked);
                              }}
                              id={"richText"}
                           />
                        </Form.Group>
                     </Col>
                  )}
                  {!["teamsbutton"].includes(feldData.type) && (
                     <Col>
                        <Form.Group className="mb-3" controlId="deprecated">
                           <Form.Check
                              inline
                              className="checkbox-container"
                              label="Veraltet (ausgeblendet, wenn leer)"
                              name="deprecated"
                              checked={feldData.deprecated}
                              type="checkbox"
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.checked);
                              }}
                              id={"deprecated"}
                           />
                        </Form.Group>
                     </Col>
                  )}
               </Row>
               <Row>
                  {!["teamsbutton"].includes(feldData.type) && (
                     <Col>
                        <Form.Group className="mb-3" controlId="autoComplete">
                           <Form.Check
                              inline
                              className="checkbox-container"
                              label="autoComplete aktiv"
                              name="autoComplete"
                              checked={feldData.autoComplete}
                              type="checkbox"
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.checked);
                              }}
                              id={"autoComplete"}
                           />
                        </Form.Group>
                     </Col>
                  )}
                  {!["teamsbutton"].includes(feldData.type) && (
                     <Col>
                        <Form.Group className="mb-3" controlId="multi">
                           <Form.Check
                              inline
                              className="checkbox-container"
                              label="multiSelect aktiv"
                              name="multi"
                              checked={feldData.multi}
                              type="checkbox"
                              onChange={(e) => {
                                 editFeld(e.target.name, e.target.checked);
                              }}
                              id={"multi"}
                           />
                        </Form.Group>
                     </Col>
                  )}
               </Row>
               <FilterGenerator editSettings={editFeld} respField={"filter"} allKacheln={allKacheln} />
               <Row>
                  <Col>
                     <Form.Group className="mb-3" controlId="filter">
                        <Form.Label>Filter (JSON)</Form.Label>
                        <Form.Control
                           autoComplete="off"
                           placeholder=""
                           style={{ minHeight: "120px" /* fieldSizing: "content" */ }}
                           as="textarea"
                           onChange={(e) => {
                              editFeld(e.target.name, e.target.value);
                           }}
                           name="filter"
                           value={feldData.filter}
                        />
                        {!isJSON(feldData.filter) && (
                           <div className="mt-1 p-1" style={{ background: "#d00", color: "#fff" }}>
                              invalide Syntax
                           </div>
                        )}
                     </Form.Group>
                  </Col>
               </Row>
               <Row>
                  <Form.Group as={Col} className="mb-3" controlId="zusatzinfos">
                     <Form.Label>Hilfstext (wird beim Hovern mit der Maus über dem Feld angezeigt)</Form.Label>
                     <Form.Control
                        autoComplete="off"
                        placeholder=""
                        as="textarea"
                        onChange={(e) => {
                           editFeld(e.target.name, e.target.value);
                        }}
                        name="title"
                        value={feldData.title}
                     />
                  </Form.Group>
               </Row>
            </Form>
         </Modal.Body>
         <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>
               Abbrechen
            </Button>
            <Button
               variant="primary"
               onClick={() => {
                  let newFeldData = { ...feldData };

                  delete newFeldData.isOnOffice;
                  if (!newFeldData.readOnly) delete newFeldData.readOnly;
                  if (!newFeldData.optional) delete newFeldData.optional;
                  if (newFeldData.filter) {
                     try {
                        newFeldData.filter = JSON.parse(newFeldData.filter);
                     } catch (error) {
                        delete newFeldData.filter;
                     }
                  }
                  if (newFeldData.contentData) {
                     try {
                        newFeldData.contentData = JSON.parse(newFeldData.contentData);
                     } catch (error) {
                        delete newFeldData.contentData;
                     }
                  }
                  if (newFeldData.options) {
                     try {
                        newFeldData.options = JSON.parse(newFeldData.options);
                     } catch (error) {
                        delete newFeldData.options;
                     }
                  }
                  if (newFeldData.optionNames) {
                     try {
                        newFeldData.optionNames = JSON.parse(newFeldData.optionNames);
                     } catch (error) {
                        delete newFeldData.optionNames;
                     }
                  }

                  saveFeld(newFeldData);
                  setShow(false);
               }}
            >
               Schließen
            </Button>
         </Modal.Footer>
      </Modal>
   );
}
